module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"preview":"Preview","showOptInMessage":"Show with opt in message","hideOptInMessage":"Hide opt in message","today":"Today","defaultMessage":"Enter message to see preview...","restart":"Restart","optInDate":"9:36 am","responseDate":"9:37 am","messageDate":"Just now","edit":"Edit","confirmationMessageDescription":"Due to text marketing laws, this content can’t be edited."}}')
  delete Component.options._Ctor
}
